module.exports = __webpack_public_path__ + "images/greenCheckMark-7374cfa8a0003b7152a9ad2874cbea99.svg";